import React, { useState, useEffect } from 'react';
import './NewsSection.css';
import { Link } from 'react-router-dom';
import { API_BASE, mediaSrc } from '../utils/api';

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
  </svg>
);

const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
  </svg>
);

const NewsSection = () => {
  const [allNews, setAllNews] = useState([]);
  const [visibleCards, setVisibleCards] = useState(6);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API_BASE}/api/news`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success) setAllNews(data.items);
        else setError('Haberler yüklenemedi.');
      })
      .catch(() => setError('Haberler şu an yüklenemiyor. Lütfen daha sonra tekrar deneyin.'));
  }, []);

  useEffect(() => {
    const update = () => setVisibleCards(window.innerWidth >= 1024 ? 8 : 6);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const visibleNews = allNews.slice(0, visibleCards);

  return (
    <section className="main-news-section">
      <h2 className="main-news-title">FENERBAHÇE HABERLER</h2>

      {error && (
        <p className="text-center text-sm text-gray-400 py-8">{error}</p>
      )}

      {!error && visibleNews.length === 0 && (
        <p className="text-center text-sm text-gray-400 py-8">Henüz haber eklenmemiş.</p>
      )}

      <div className="main-news-grid">
        {visibleNews.map((item) => (
          <Link key={item.id} to={`/news/${item.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <article className="main-news-card" style={{ cursor: 'pointer' }}>
              <div className="main-news-card-image">
                <img src={mediaSrc(item.image)} alt={item.title} />
              </div>
              <div className="main-news-card-content">
                <div className="main-news-card-info">
                  <h3 className="main-news-card-title">{item.title}</h3>
                  <p className="main-news-card-description">{item.description}</p>
                </div>
                <div className="main-news-card-meta">
                  <span className="main-news-card-category" style={{ color: item.categoryColor }}>
                    <span className="main-category-color-dot" style={{ backgroundColor: item.categoryColor }}></span>
                    {item.category}
                  </span>
                  <span className="main-news-card-date">
                    <ClockIcon /> {item.date}
                  </span>
                </div>
              </div>
            </article>
          </Link>
        ))}
      </div>

      {allNews.length > visibleCards && (
        <div className="main-news-more-button-wrapper">
          <Link to="/news" className="main-news-more-button">
            <span>Daha Fazlası</span>
            <ArrowIcon />
          </Link>
        </div>
      )}
    </section>
  );
};

export default NewsSection;
